import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card-group-item" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "form-check form-switch" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "lokationSwitch",
  style: {"margin-top":"0.15rem !important"}
}, " Lokationer ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "float-end mt-1" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn-close btn-sm" })
], -1)
const _hoisted_7 = {
  key: 0,
  class: "card-body"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "form-check small" }
const _hoisted_11 = ["id", "value"]
const _hoisted_12 = { class: "form-check-label" }

import { ref, Ref, computed, watch } from "vue";
import { useQuery, useResult } from "@vue/apollo-composable";
import { LOKATIONER_OPSLAG } from "@/constants/graphql";

export default /*#__PURE__*/_defineComponent({
  __name: 'Lokationsfilter',
  props: {
    lokationer: null
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update", value: string[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  lokationer: string[];
}



const valgteLokationer: Ref<string[] | null> = ref<string[]>(null);
const knap: Ref<boolean> = ref(true);

const { result: lokationResult, loading: lokationLoading } = useQuery(
  LOKATIONER_OPSLAG
);

const lokationer = useResult(
  lokationResult,
  null,
  data => data.muligePlaceringer
);

const filter = computed({
  get() {
    return valgteLokationer.value != null
      ? valgteLokationer.value
      : props.lokationer;
  },
  set(lokation: string[]) {
    valgteLokationer.value = lokation;
    emit("update", valgteLokationer.value);
  }
});

watch(props, () => {
  valgteLokationer.value = props.lokationer;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            role: "switch",
            id: "lokationSwitch",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((knap).value = $event))
          }, null, 512), [
            [_vModelCheckbox, knap.value]
          ]),
          _hoisted_5,
          _hoisted_6
        ])
      ])
    ]),
    (knap.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_unref(lokationLoading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Indlæser... "))
            : (_openBlock(), _createElementBlock("form", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lokationer), (lokation) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: lokation.navn
                  }, [
                    _createElementVNode("label", _hoisted_10, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: lokation.navn,
                        value: lokation.navn,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(filter) ? (filter).value = $event : null))
                      }, null, 8, _hoisted_11), [
                        [_vModelCheckbox, _unref(filter)]
                      ]),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(lokation.navn), 1)
                    ])
                  ]))
                }), 128))
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})